import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const qs = (data = {}) => {
  const params = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params[key] = value;
  });
  return new URLSearchParams(params).toString();
};

export const fetchPowerReturnListApi = (data = {}) =>
  axios.get(`/admin/power-customer-return/list?${qs(data)}`, setJwtToken());

export const fetchPowerReturnSettingsApi = () =>
  axios.get("/admin/power-customer-return/settings", setJwtToken());

export const savePowerReturnSettingsApi = (data) =>
  axios.put("/admin/power-customer-return/settings", data, setJwtToken());

export const updatePowerReturnReminderApi = (data) =>
  axios.put("/admin/power-customer-return/toggle", data, setJwtToken());
